module.exports = __webpack_public_path__ + "static/media/branding-img7.999b0329.jpg";